import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { TravelCashService } from '../../services/travel-cash/travel-cash.service';
import { travelAuthorUrl } from 'src/app/modules/shared/common/api';
import { TravelCashAdvanceCancelComponent } from '../travel-cash-advance-cancel/travel-cash-advance-cancel.component';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { TravelItineraryViewComponent } from 'src/app/modules/shared/components/travel-itinerary-view/travel-itinerary-view.component';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

@Component({
  selector: 'app-travel-cash-advance-view',
  templateUrl: './travel-cash-advance-view.component.html',
  styleUrls: ['./travel-cash-advance-view.component.scss']
})
export class TravelCashAdvanceViewComponent implements OnInit {

  
  travel: Travel;
  user: User;
  formGroup: FormGroup;
  loading:boolean = false;
  isNoResult:boolean = false;
  show:boolean = false
  isCharged:boolean = false;
  isCurrency:boolean = false;
  isOther:boolean = false;
  successMessage: String = '';
  total = 0;
  mealTotal = 0;
  selectedIndex = 0;
  transportFee = 0;
  currency_category = 0;
  charge_category = 0;
  headlabel = 'View';
  objectKeys = Object.keys;
  expensesList:any;
  msg = "";

  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }

  dialogConfig:any;
  summaryDetail:any;
  detail:any;
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));
  
  travelOption = ["Individual","Group"];
  purposeOption = ["Store Opening Setup","HR Meeting","Others"];
  natureOption = ["Inbound","Outbound"];
  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"}
  ];
  bookedOption = ["Office Booking","Self Booking"];
  billOption = ["Store Support Center","Requestor"];

  province = [{origin:''},{destination: ''}];
  city = [{city:''},{city: ''}];
  barangay = [{barangay:'' },{barangay: ''}];
 

  pipe = new DatePipe('en-US');

  constructor(
    public dialogRef: MatDialogRef<TravelCashAdvanceViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelCashService: TravelCashService,
    public travelService: TravelService,
    private formBuilder: FormBuilder,
    public functionService: FunctionsService,
    public auth: AuthService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.user = new User(this.auth.getAuthUser());
    this.travel = new Travel(this.data.res);
    this.detail = this.data.res;
    this.formGroup = this.formBuilder.group({
      date_filed:['',null],
      itinerary_date: ['',null],
      travel_authorization_no: ['',null],
      travel_authorization_id: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      department: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      travel_type: ['',null],
      copy_date: ['',null],
      purpose: ['',null],
      location: ['',null],
      nature: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      currency: ['',null],
      amount: ['',null],
      charged_to: ['',null],
      booked_by: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accomodation: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      misc_breakdown:['',null],
      others:['',null]
    });
    this.formGroup.controls['misc_breakdown'].setValue(this.travel.misc_breakdown);
    this.travel.formGroup = this.formGroup;
    this.travel.disableForm();
    this.formGroup.controls['employee_id_no'].setValue(this.user.employee_id);
    this.formGroup.controls['area_covered'].setValue(this.travel.list.travel_authorization.area_covered);
    this.formGroup.controls['position'].setValue(this.travel.list.travel_authorization.position);
    this.formGroup.controls['department'].setValue(this.travel.list.travel_authorization.department);
    this.formGroup.controls['payroll_acct_no'].setValue(this.travel.list.travel_authorization.payroll_acct_no);
    this.formGroup.controls['booked_by'].setValue(this.travel.list.travel_authorization.travel_summary.booked_by);
    this.formGroup.controls['charged_to'].setValue(this.travel.list.travel_authorization.travel_summary.charged_to);
    this.formGroup.controls['currency'].setValue(this.travel.list.travel_authorization.travel_summary.currency);
    this.formGroup.controls['currency_category'].setValue(this.travel.list.travel_authorization.travel_summary.currency_category);
    this.formGroup.controls['charged_to_category'].setValue(this.travel.list.travel_authorization.travel_summary.charged_to_category);
    this.formGroup.controls['inclusive_date_from'].setValue(this.travel.list.travel_authorization.travel_summary.inclusive_date_from);
    this.formGroup.controls['inclusive_date_to'].setValue(this.travel.list.travel_authorization.travel_summary.inclusive_date_to);
    this.formGroup.controls['location'].setValue(this.travel.list.travel_authorization.travel_summary.location);
    this.formGroup.controls['nature'].setValue(this.travel.list.travel_authorization.travel_summary.nature);
    this.formGroup.controls['travel_type'].setValue(this.travel.list.travel_authorization.travel_summary.travel_type);
    this.formGroup.controls['others'].setValue(this.travel.list.travel_authorization.travel_summary.others);
    this.travel.itineraries = this.data.res.travel_authorization.travel_itineraries;

    let purposeOption = this.travel.list.travel_authorization.travel_summary.purpose.split("|");
    this.formGroup.controls['purpose'].setValue(purposeOption[0]);
    this.data.isOther = false;
    if (purposeOption[0] == "Others") {
      this.isOther = true;
      this.data.isOther = true;
      //this.formGroup.controls['others'].setValue(purposeOption[1]);
    }

    this.expensesList  = this.functionService.loopRangeDate(
      [
        this.travel.list.travel_authorization.travel_summary.inclusive_date_from,
        this.travel.list.travel_authorization.travel_summary.inclusive_date_to
      ],
      this.data.res.travel_authorization.travel_itineraries
    );


    this.travel.getTotal();

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';

  }

  
  closeOnClick() {
    this.dialogRef.close(true);
  }
  

  save(bool:boolean){
    this.loading = true;
    this.travel.enableForm();
    this.formGroup.controls['is_draft'].setValue(bool);
    this.formGroup.controls['travel_authorization_id'].setValue(this.travel.list.travel_authorization.id);
    this.formGroup.controls['travel_authorization_no'].setValue(this.travel.list.travel_authorization.travel_authorization_no);
    this.travelCashService.updateCash(this.travel.id,this.formGroup.value).subscribe(res=>{
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(this.formGroup.value);
        }
      });
    },(err => {
      this.loading = false;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

  /**
   * View itinerary Details Modal
   * @param res 
   */
  viewItinerary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 1,
      displayEdit: false
    }
    let dialogRef = this.dialog.open(TravelItineraryViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

   /**
   * Delete Travel Authorization Data
   */
  deleteAsDraft() {
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this draft?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete();
      }
    });
  }

  delete() {
    this.loading = true;
    let data = {
      status: 'Delete as Draft',

    }
    this.travelCashService.updateStatus(this.data.res.id,data).subscribe(res=>{
      
      this.msg = "";
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(true);
        }
      });

    },(err =>{
      this.loading = false;
    }));
  }

  close(){
    this.msg = "";
  }

  /**
   * Display Currency option
   * @param e = 3 get value for other currency
   */
  displayCurrency(e) {
    this.isCurrency = false;
    this.formGroup.get('currency_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCurrency = true;
      }
    })
  }

  /**
   * Display other supplier
   * @param e  e = 3 get value for supplier
   */
  displayCharge(e) {
    this.isCharged = false;
    this.formGroup.get('charged_to_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCharged = true;
      }
    })
  }

  edit(){
    this.show = true;
    this.headlabel =  'Edit';
    this.selectedIndex = 2;
    this.formGroup.controls['misc_breakdown'].enable();
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
     return pattern.test(e.key);
  }

  cancelCa(){
    this.dialogConfig.width = '800px';
    this.dialogConfig.data = {
      id: this.data.res.id
    }
    let dialogRef = this.dialog.open(TravelCashAdvanceCancelComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.travel.list.ca_status = result.ca_status;
        this.travel.status_id = result.status_id;
        this.dialogRef.close(true);
      }
    });
  }
}
